import { Injectable } from '@angular/core';
import * as data from '../../environments/version'

@Injectable()
export class LocalstorageService {

  versionExist: boolean = false;
  constructor() {
    if (data && data.VERSION)
      this.versionExist = true;
  }

  updateLocalStorage() {
    localStorage.setItem('versionApp', JSON.stringify({ 'version': data.VERSION.version }))
    localStorage.removeItem('finderData')
    localStorage.removeItem('hideDamageType')
    localStorage.removeItem('classification')
    window.location.reload();
  }

  checkVersion() {
    return new Promise((resolve, reject) => {
      let localVersion = JSON.parse(localStorage.getItem('versionApp')).version;
      if (this.versionExist && localVersion !== data.VERSION.version) {
        console.log("version change", localVersion, data.VERSION.version);
        reject()
      } else {
        resolve()
      }
    })
  }


  getItem(string: string): string | null {
    this.checkVersion().then(() => { }).catch(() => { this.updateLocalStorage() })
    return localStorage.getItem(string)
  }

  setItem(key: string, value: string): void {
    this.checkVersion().then(() => { localStorage.setItem(key, value) }).catch(() => { this.updateLocalStorage() })
  }

  removeItem(key: string): void {
    this.checkVersion().then(() => { localStorage.removeItem(key) }).catch(() => { this.updateLocalStorage() })
  }

  clear() {
    localStorage.clear();
  }

}



// WEBPACK FOOTER //
// ./src/app/service/localstorage.service.ts